module.exports = __webpack_public_path__ + "img/Verband_Logistik.ae1d257e.svg";